export default "__VITE_ASSET__CbWcLDZ2__"